import type { IntlShape } from 'react-intl'

export interface LoyaltyLandingPageBenefitDetails {
  title: React.ReactNode
  description: React.ReactNode
  image: App.Image
  benefitCode: App.LoyaltyBenefitType
  enabled: boolean
}

export type LoyaltyLandingPageBenefitCopy = Record<
  App.LoyaltyBenefitType,
  LoyaltyLandingPageBenefitDetails | undefined
>

export const getLoyaltyLandingPageBenefitCopy = (
  enabledBenefits: App.LoyaltyRegionEnabledBenefits,
  intl: IntlShape,
): LoyaltyLandingPageBenefitCopy => {
  return {
    hotel_upgrade: {
      title: intl.formatMessage({
        id: 'Rgs6todiX7',
        defaultMessage: 'Upgrade your stay',
        description: 'Loyalty benefit title for hotel room upgrade benefit',
      }),
      description: intl.formatMessage({
        id: '9/k8yA7VkN',
        defaultMessage: 'Enjoy complimentary room and package upgrades on select offers. Your upgrade is guaranteed as soon as you book, ensuring a seamless check-in with no surprises.',
        description: 'Loyalty benefit description for hotel room upgrade benefit',
      }),
      image: {
        id: 'wfzka1j5ru5d5e7hc9u',
        title: 'Free room and package upgrades',
      },
      benefitCode: 'hotel_upgrade',
      enabled: enabledBenefits.hotel_upgrade,
    },
    airport_transfer: {
      title: intl.formatMessage({
        id: 'BpCwwAEHJn',
        defaultMessage: 'Travel in style with private chauffeur transfers',
        description: 'Loyalty benefit title for airport transfer benefit',
      }),
      description: intl.formatMessage({
        id: 'mWaHTMKMWR',
        defaultMessage: 'Start and end your journey smoothly with free private airport transfers in select destinations. No stress, just seamless service.',
        description: 'Loyalty benefit description for airport transfer benefit',
      }),
      image: {
        id: '0qt5tc9nvf1qd3f0t5fe',
        title: 'Free airport chauffeur service',
      },
      benefitCode: 'airport_transfer',
      enabled: enabledBenefits.airport_transfer,
    },
    lounge_pass: {
      title: intl.formatMessage({
        id: 'iPDXaTjCyZ',
        defaultMessage: 'Lounge in comfort before your flight',
        description: 'Loyalty benefit title for airport lounge pass benefit',
      }),
      description: intl.formatMessage({
        id: 'W2OMfseVTx',
        defaultMessage: 'Unwind with a drink, a bite to eat, and a quiet space to relax, the perfect start to your Luxury Escape.',
        description: 'Loyalty benefit description for airport lounge pass benefit',
      }),
      image: {
        id: 'rq13k5lzgr8oxoz3a2',
        title: 'Free airport lounge passes',
      },
      benefitCode: 'lounge_pass',
      enabled: enabledBenefits.lounge_pass,
    },
    phone_support: {
      title: intl.formatMessage({
        id: 'sl3fecu8rn',
        defaultMessage: 'Priority support',
        description: 'Loyalty benefit title for priority phone support benefit',
      }),
      description: intl.formatMessage({
        id: 'nmib7siN7n',
        defaultMessage: 'Skip the queue with 24/7 access to our dedicated support team, always here to help, whenever you need us.',
        description: 'Loyalty benefit description for priority phone support benefit',
      }),
      image: {
        id: 'kf3r6fahlubu2yb1htkgb',
        title: 'Faster, priority support',
      },
      benefitCode: 'phone_support',
      enabled: enabledBenefits.phone_support,
    },
    travelshoot_credit: {
      title: intl.formatMessage({
        id: '8lIkelcSii',
        defaultMessage: 'Discounted photoshoots',
        description: 'Loyalty benefit title for Travelshoot photo credit benefit',
      }),
      description: intl.formatMessage({
        id: 'Nv8nJ5wZJD',
        defaultMessage: 'Capture your escape in style with exclusive discounts on professional Travelshoot photo sessions at your destination.',
        description: 'Loyalty benefit description for Travelshoot photo credit benefit',
      }),
      image: {
        id: 'r1z816jjifeqb5hwk50o',
        title: 'Pro photos on your trip',
      },
      benefitCode: 'travelshoot_credit',
      enabled: enabledBenefits.travelshoot_credit,
    },
    tour_exp_credit: {
      title: intl.formatMessage({
        id: 'eqnhoGepP4',
        defaultMessage: 'Extras on your tour',
        description: 'Loyalty benefit title for tour experience credit benefit',
      }),
      description: intl.formatMessage({
        id: '64RQKiTDFk',
        defaultMessage: 'Unlock credits for exclusive add-ons, from relaxing massages to local food experiences.',
        description: 'Loyalty benefit description for tour experience credit benefit',
      }),
      image: {
        id: '69vg83q7obl8xw4x1ac',
        title: 'Extras on your tour',
      },
      benefitCode: 'tour_exp_credit',
      enabled: enabledBenefits.tour_exp_credit,
    },
    discounted_insurance: {
      title: intl.formatMessage({
        id: 'ekNGW6zLfI',
        defaultMessage: 'Discounted travel insurance',
        description: 'Loyalty benefit title for discounted insurance benefit',
      }),
      description: intl.formatMessage({
        id: '7f1DmM3PpC',
        defaultMessage: 'Save on Travel & Cancellation Protection',
        description: 'Loyalty benefit description for discounted insurance benefit',
      }),
      image: {
        id: '36fmxwdnmim0b53p9x7',
        title: 'Travel & Cancellation Protection',
      },
      benefitCode: 'discounted_insurance',
      enabled: enabledBenefits.discounted_insurance,
    },
    early_access: undefined,
    hidden_access: undefined,
  }
}
